<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row class="mt-4">
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('ORIGINAL_TITLE_OF_HIGHER_QUALIFICATION')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-1" placement="top" triggers="focus">{{$t('ORIGINAL_TITLE_OF_HIGHER_QUALIFICATION_MORE')}}</b-tooltip>
            <b-form-input
              type="text"
              v-model.trim="name_of_foreign_qualification"
              id="tooltip-target-1">
            </b-form-input>
            <validation-description
              :show="$v.name_of_foreign_qualification.$dirty && $v.name_of_foreign_qualification.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group label-size="sm" :label="$t('ORIGINAL_NAME_THE_SUPPORTING_DOCUMENTATION')">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-2" placement="top" triggers="focus">{{$t('ORIGINAL_NAME_THE_SUPPORTING_DOCUMENTATION_MORE')}}</b-tooltip>
            <b-form-input
              v-model.trim="original_name_accompanying_public_document"
              id="tooltip-target-2">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group label-size="sm" :label="$t('TITLE_OF_QUALIFICATION_TRANSLATED')">
            <b-form-input
              v-model.trim="title_of_qualification_translated">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('SCIENTIFIC_AREA')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-3" placement="top" triggers="focus">{{$t('SCIENTIFIC_AREA_MORE')}}</b-tooltip>
            <b-select type="select" v-model="qualification_area.id" id="tooltip-target-3">
              <option :key="item.id" :value="item.id" v-for="item in qualification_list">{{ item.name }}</option>
            </b-select>
            <validation-description
              :show="$v.qualification_area.$dirty && $v.qualification_area.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('STUDIES_LEVEL')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-17" placement="top" triggers="focus">{{$t('STUDIES_LEVEL_MORE')}}</b-tooltip>
            <b-select :options="studies_level"
                      type="select"
                      v-model="study_level"
                      id="tooltip-target-17">
            </b-select>
            <validation-description :show="$v.study_level.$dirty && $v.study_level.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('EQF_LEVEL')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-4" placement="top" triggers="focus">{{$t('EQF_LEVEL_MORE')}}</b-tooltip>
            <b-select :options="options_eqf_level"
                      type="select"
                      v-model="eqf_level"
                      id="tooltip-target-4">
            </b-select>
            <validation-description :show="$v.eqf_level.$dirty && $v.eqf_level.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('LEVEL_OF_QUALIFICATION_IN_COUNTRY_RECOGNITION')" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-5" placement="top" triggers="focus">{{$t('LEVEL_OF_QUALIFICATION_IN_COUNTRY_RECOGNITION')}}</b-tooltip>
            <b-select :options="options_nqf"
                      type="select"
                      v-model="nqf"
                      id="tooltip-target-5"
                      >
            </b-select>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('TYPE_STUDY')" label-size="sm">
            <b-select :options="type_study_options"
                      type="select"
                      v-model="type_study"
            >
            </b-select>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4" v-if="institution && institution.hasOwnProperty('id') && institution.id === 22"><!-- only Kosovo -->
          <b-form-group label="Erasmus+ Areas" label-size="sm" >
            <b-select :options="erasmus_area_list"
                      type="select"
                      text-field="name"
                      value-field="value"
                      v-model="erasmus_area"
            >
            </b-select>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('ECTS_ENROLLMENT')" label-size="sm">
            <b-form-input v-model="ects_enrollment"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="`${$t('NAME_OF_FOREIGN_STUDY_PROGRAM')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-7"  placement="top" triggers="focus">{{$t('NAME_OF_FOREIGN_STUDY_PROGRAM_MORE')}}</b-tooltip>
            <b-form-input
              v-model="name_of_study_program_country_origin "
              id="tooltip-target-7">
            </b-form-input>
            <validation-description :show="$v.name_of_study_program_country_origin.$dirty && $v.name_of_study_program_country_origin.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('CONDITIONS_FOR_ENTRY')" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-6" placement="top" triggers="focus">{{$t('CONDITIONS_FOR_ENTRY_MORE')}}</b-tooltip>
            <b-select :options="options_enrollment_requirements"
                      type="select"
                      v-model="enrollment_requirements"
                      id="tooltip-target-6"
            >
            </b-select>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="4" lg="4">
          <b-form-group :label="$t('ECTS')" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-9" placement="top" triggers="focus">{{$t('ECTS_MORE')}}</b-tooltip>
            <b-form-input
              v-model.trim="ects"
              name="ects"
              id="tooltip-target-9">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="2" lg="4">
          <b-form-group :label="`${$t('LENGTH_OF_STUDY')} *`" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-10" placement="top" triggers="focus">{{$t('LENGTH_OF_STUDY_MORE')}}</b-tooltip>
            <b-form-input
              step="0.5"
              min="1"
              type="number"
              v-model.trim="length_of_study"
              name="length_of_study"
              id="tooltip-target-10"
            >
            </b-form-input>
            <validation-description :show="$v.length_of_study.$dirty && $v.length_of_study.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </validation-description>
          </b-form-group>
        </b-col>
        <b-col class="mb-3" md="6" lg="4">
          <b-form-group :label="$t('FURTHER_STUDY')" label-size="sm">
            <b-tooltip v-if="showTooltipe" target="tooltip-target-15" placement="top" triggers="focus">{{$t('FURTHER_STUDY_MORE')}}</b-tooltip>
            <b-select :options="options"
                      type="select"
                      v-model="further_study"
                      id="tooltip-target-15">
            </b-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="6" lg="6">
          <submit-button :disabled="applicant.status && applicant.status.id !== STATUS_IN_PROCESS || disabled" :loading="loading" :c_permission="C_RECOGNITION_SAVE_BUTTON"></submit-button>
        </b-col>
      </b-row>
    </b-form>
  </div>

</template>

<script>
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import SubmitButton from '@/components/app/AppSubmit'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import Country from '@/components/applicant/recognation/fields/Country'
  import {getRecognition,getQualificationAreaList,createRecognition,updateRecognition} from '@/services/recognition/index'
  import {getUser} from "@/services/user";
  import i18n from '@/locale/index'
  import moment from 'moment'
  import {C_RECOGNITION_SAVE_BUTTON} from '@/shared/component_permission'
  import {STATUS_COMPLETE,STATUS_IN_PROCESS} from '@/shared/constants';
  import loading from 'vue-full-loading'


  export default {
    name: "RecognitionEvaluationForm",
    data() {
      return {
        loading:false,
        mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
        qualification_list:[],
        C_RECOGNITION_SAVE_BUTTON,
        STATUS_IN_PROCESS,
        STATUS_COMPLETE,
         disabled: false,
        options: [
          {value: null, text: '-'},
          {value: 1, text: i18n.t('YES')},
          {value: 0, text: i18n.t('NO')}
        ],
        options_t: [
          {value: 1, text: i18n.t('YES')},
          {value: 0, text: i18n.t('NO')}
         ],
        recognized: [
          {value: null, text: '-'},
          {value: 'akreditirana', text: i18n.t('ACCREDITED')},
          {value: 'licencirana', text: i18n.t('LICENSED')}
        ],
        options_eqf_level:[
          {value:null ,text:'-'},
          {value:1 ,text:1},
          {value:2 ,text:2},
          {value:3 ,text:3},
          {value:4 ,text:4},
          {value:5 ,text:5},
          {value:6 ,text:6},
          {value:7 ,text:7},
          {value:8 ,text:8},
          {value:0 ,text:this.$t('NOT_APPLICABLE')}
        ],
        options_nqf:[
          {value:null ,text:'-'},
          {value:1 ,text:1},
          {value:2 ,text:2},
          {value:3 ,text:3},
          {value:4 ,text:4},
          {value:5 ,text:5},
          {value:6 ,text:6},
          {value:7 ,text:7},
          {value:8 ,text:8},
          {value:9 ,text:9},
          {value:10 ,text:10},
          {value:11 ,text:11},
          {value:12 ,text:12},
          {value:0 ,text:this.$t('NOT_APPLICABLE')}
        ],
        studies_level: [
          {value: null, text: '-'},
          {value: 1, text: i18n.t('SHORT_CYCLE')},
          {value: 2, text: i18n.t('FIRST_CYCLE')},
          {value: 3, text: i18n.t('SECOND_CYCLE')},
          {value: 4, text: i18n.t('THIRD_CYCLE')},
          {value: 5, text: i18n.t('PREGRADUATE')},
          {value: 6, text: i18n.t('GRADUATE')},
          {value: 7, text: i18n.t('POSTGRADUATE')},
          {value: 8, text: i18n.t('OTHER')},
        ],
        type_study_options: [
          {value: null, text: '-'},
          {value: 1, text: this.$t('FULL_TIME')},
          {value: 2, text: this.$t('PART_TIME')},
          {value: 3, text: this.$t('ONLINE')},
          {value: 4, text: this.$t('DISTANCE_LEARNING')},
          {value: 5, text: this.$t('HYBRID')},
        ],
        options_enrollment_requirements: [
          {value: null, text: '-'},
          {value: 1, text: i18n.t('SECONDARY')},
          {value: 2, text: i18n.t('SHORT_CYCLE')},
          {value: 3, text: i18n.t('FIRST_CYCLE')},
          {value: 4, text: i18n.t('SECOND_CYCLE')},
          {value: 5, text: i18n.t('PREGRADUATE')},
          {value: 6, text: i18n.t('GRADUATE')},
          {value: 7, text: i18n.t('OTHER')},
        ],
        erasmus_area_list: [
          { value: null, name: "-" },
          { value: "010", name: this.$t('ERASMUS_AREA.AGRICULTURAL_SCIENCES') },
          { value: "011", name: this.$t('ERASMUS_AREA.AGRICULTURE') },
          { value: "012", name:this.$t('ERASMUS_AREA.AGRICULTURAL_ECONOMICS') },
          { value: "013", name:this.$t('ERASMUS_AREA.FOOD_SCIENCE_AND_TECHNOLOGY') },
          { value: "014", name:this.$t('ERASMUS_AREA.HORTICULTURE') },
          { value: "015", name:this.$t('ERASMUS_AREA.FISHERIES') },
          { value: "016", name:this.$t('ERASMUS_AREA.FORESTRY') },
          { value: "017", name:this.$t('ERASMUS_AREA.ANIMAL_HUSBANDRY') },
          { value: "018", name:this.$t('ERASMUS_AREA.TROPICAL_SUBTROPICAL') },
          { value: "019", name:this.$t('ERASMUS_AREA.OTHER_AGRICULTURAL') },
          { value: "020", name:this.$t('ERASMUS_AREA.ARCHITECTURE_URBAN_REGIONAL_PLANNING') },
          { value: "021", name:this.$t('ERASMUS_AREA.ARCHITECTURE') },
          { value: "022", name:this.$t('ERASMUS_AREA.INTERIOR_DESIGN') },
          { value: "023", name:this.$t('ERASMUS_AREA.URBAN_PLANNING') },
          { value: "024", name:this.$t('ERASMUS_AREA.REGIONAL_PLANNING') },
          { value: "025", name:this.$t('ERASMUS_AREA.LANDSCAPE_ARCHITECTURE') },
          { value: "026", name:this.$t('ERASMUS_AREA.TRANSPORT_AND_TRAFFIC_STUDIES') },
          { value: "029", name:this.$t('ERASMUS_AREA.OTHERS_ARCHITECTURE') },
          { value: "030", name:this.$t('ERASMUS_AREA.ART_AND_DESIGN') },
          { value: "031", name:this.$t('ERASMUS_AREA.FINE_ART') },
          { value: "032", name:this.$t('ERASMUS_AREA.MUSIC_AND_MUSICOLOGY') },
          { value: "033", name:this.$t('ERASMUS_AREA.PERFORMING_ARTS') },
          { value: "034", name:this.$t('ERASMUS_AREA.PHOTOGRAPHY_CINEMATOGRAPHY') },
          { value: "035", name:this.$t('ERASMUS_AREA.DESIGN') },
          { value: "036", name:this.$t('ERASMUS_AREA.HISTORY_OF_ART') },
          { value: "039", name:this.$t('ERASMUS_AREA.OTHERS_ART_AND_DESIGN') },
          { value: "040", name:this.$t('ERASMUS_AREA.BUSINESS_STUDIES_AND_MANAGEMENT') },
          { value: "041", name:this.$t('ERASMUS_AREA.BUSINESS_STUDIES_WITH_LANGUAGES') },
          { value: "042", name:this.$t('ERASMUS_AREA.BUSINESS_STUDIES_WITH_TECHNOLOGY') },
          { value: "043", name:this.$t('ERASMUS_AREA.ACCOUNTANCY_FINANCIAL_MANAGEMENT') },
          { value: "044", name:this.$t('ERASMUS_AREA.TOURISM_CATERING_HOTEL_MANAGEMENT') },
          { value: "045", name:this.$t('ERASMUS_AREA.INDUSTRIAL_RELATIONS_AND_PERSONNEL') },
          { value: "046", name:this.$t('ERASMUS_AREA.SECRETARIAL_STUDIES') },
          { value: "047", name:this.$t('ERASMUS_AREA.MARKETING_AND_SALES_MANAGEMENT') },
          { value: "049", name:this.$t('ERASMUS_AREA.OTHERS_BUSINESS_STUDIES') },
          { value: "050", name:this.$t('ERASMUS_AREA.EDUCATION_TEACHER_TRAINING') },
          { value: "051", name:this.$t('ERASMUS_AREA.TEACHER_TRAINING') },
          { value: "052", name:this.$t('ERASMUS_AREA.PRIMARY_EDUCATION') },
          { value: "053", name:this.$t('ERASMUS_AREA.SECONDARY_EDUCATION') },
          { value: "054", name:this.$t('ERASMUS_AREA.VOCATIONAL_AND_TECHNICAL_EDUCATION') },
          { value: "055", name:this.$t('ERASMUS_AREA.ADULT_EDUCATION') },
          { value: "056", name:this.$t('ERASMUS_AREA.SPECIAL_EDUCATION') },
          { value: "057", name:this.$t('ERASMUS_AREA.EDUCATIONAL_SCIENCE_COMPARATIVE') },
          { value: "058", name:this.$t('ERASMUS_AREA.EDUCATIONAL_PSYCHOLOGY') },
          { value: "059", name:this.$t('ERASMUS_AREA.OTHERS_EDUCATION_TEACHER_TRAINING') },
          { value: "060", name:this.$t('ERASMUS_AREA.ENGINEERING_TECHNOLOGY') },
          { value: "061", name:this.$t('ERASMUS_AREA.MECHANICAL_ENGINEERING') },
          { value: "062", name:this.$t('ERASMUS_AREA.ELECTRICAL_ENGINEERING') },
          { value: "063", name:this.$t('ERASMUS_AREA.CHEMICAL_ENGINEERING') },
          { value: "064", name:this.$t('ERASMUS_AREA.CIVIL_ENGINEERING') },
          { value: "065", name:this.$t('ERASMUS_AREA.ELECTRONIC_ENGINEERING') },
          { value: "066", name:this.$t('ERASMUS_AREA.MANUFACTURING_SCIENCES_INCLUDING_CAD') },
          { value: "067", name:this.$t('ERASMUS_AREA.MATERIALS_SCIENCE') },
          { value: "068", name:this.$t('ERASMUS_AREA.AERONAUTICAL_ENGINEERING') },
          { value: "069", name:this.$t('ERASMUS_AREA.OTHERS_ENGINEERING_TECHNOLOGY') },
          { value: "070", name:this.$t('ERASMUS_AREA.GEOGRAPHY_GEOLOGY') },
          { value: "071", name:this.$t('ERASMUS_AREA.GEOGRAPHY') },
          { value: "072", name:this.$t('ERASMUS_AREA.ENVIRONMENTAL_SCIENCES_ECOLOGY') },
          { value: "073", name:this.$t('ERASMUS_AREA.GEOLOGY') },
          { value: "074", name:this.$t('ERASMUS_AREA.SOIL_AND_WATER_SCIENCES') },
          { value: "076", name:this.$t('ERASMUS_AREA.GEODESY_CARTOGRAPHY_REMOTE_SENSING') },
          { value: "077", name:this.$t('ERASMUS_AREA.METEOROLOGY') },
          { value: "079", name:this.$t('ERASMUS_AREA.OTHERS_GEOGRAPHY_GEOLOGY') },
          { value: "080", name:this.$t('ERASMUS_AREA.HUMANITIES') },
          { value: "081", name:this.$t('ERASMUS_AREA.PHILOSOPHY') },
          { value: "082", name:this.$t('ERASMUS_AREA.THEOLOGY') },
          { value: "083", name:this.$t('ERASMUS_AREA.HISTORY') },
          { value: "084", name:this.$t('ERASMUS_AREA.ARCHAEOLOGY') },
          { value: "089", name:this.$t('ERASMUS_AREA.OTHERS_HUMANITIES') },
          { value: "090", name:this.$t('ERASMUS_AREA.LANGUAGES_AND_PHILOLOGICAL_SCIENCES') },
          { value: "091", name:this.$t('ERASMUS_AREA.MODERN_EC_LANGUAGES') },
          { value: "092", name:this.$t('ERASMUS_AREA.GENERAL_AND_COMPARATIVE_LITERATURE') },
          { value: "093", name:this.$t('ERASMUS_AREA.LINGUISTICS') },
          { value: "094", name:this.$t('ERASMUS_AREA.TRANSLATION_INTERPRETATION') },
          { value: "095", name:this.$t('ERASMUS_AREA.CLASSICAL_PHILOLOGY') },
          { value: "096", name:this.$t('ERASMUS_AREA.NON_EC_LANGUAGES') },
          { value: "098", name:this.$t('ERASMUS_AREA.LESS_WIDELY_TAUGHT_LANGUAGES') },
          { value: "099", name:this.$t('ERASMUS_AREA.OTHERS_LANGUAGES_AND_PHILOLOGICAL') },
          { value: "100", name:this.$t('ERASMUS_AREA.LAW') },
          { value: "101", name:this.$t('ERASMUS_AREA.COMPARATIVE_LAW_WITH_LANGUAGES') },
          { value: "102", name:this.$t('ERASMUS_AREA.INTERNATIONAL_LAW') },
          { value: "103", name:this.$t('ERASMUS_AREA.CIVIL_LAW') },
          { value: "104", name:this.$t('ERASMUS_AREA.CRIMINAL_LAW_CRIMINOLOGY') },
          { value: "105", name:this.$t('ERASMUS_AREA.CONSTITUTIONAL_PUBLIC_LAW') },
          { value: "106", name:this.$t('ERASMUS_AREA.PUBLIC_ADMINISTRATION') },
          { value: "107", name:this.$t('ERASMUS_AREA.EUROPEAN_COMMUNITY_EU_LAW') },
          { value: "109", name:this.$t('ERASMUS_AREA.OTHERS_LAW') },
          { value: "110", name:this.$t('ERASMUS_AREA.MATHEMATICS_INFORMATICS') },
          { value: "111", name:this.$t('ERASMUS_AREA.MATHEMATICS') },
          { value: "112", name:this.$t('ERASMUS_AREA.STATISTICS') },
          { value: "113", name:this.$t('ERASMUS_AREA.INFORMATICS_COMPUTER_SCIENCE') },
          { value: "114", name:this.$t('ERASMUS_AREA.ARTIFICIAL_INTELLIGENCE') },
          { value: "115", name:this.$t('ERASMUS_AREA.ACTUARIAL_SCIENCE') },
          { value: "119", name:this.$t('ERASMUS_AREA.OTHERS_MATHEMATICS_INFORMATICS') },
          { value: "120", name:this.$t('ERASMUS_AREA.MEDICAL_SCIENCES') },
          { value: "121", name:this.$t('ERASMUS_AREA.MEDICINE') },
          { value: "122", name:this.$t('ERASMUS_AREA.PSYCHIATRY_AND_CLINICAL_PSYCHOLOGY') },
          { value: "123", name:this.$t('ERASMUS_AREA.DENTISTRY') },
          { value: "124", name:this.$t('ERASMUS_AREA.VETERINARY_MEDICINE') },
          { value: "125", name:this.$t('ERASMUS_AREA.PHARMACY') },
          { value: "126", name:this.$t('ERASMUS_AREA.NURSING_MIDWIFERY_PHYSIOTHERAPY') },
          { value: "127", name:this.$t('ERASMUS_AREA.PUBLIC_HEALTH') },
          { value: "128", name:this.$t('ERASMUS_AREA.MEDICAL_TECHNOLOGY') },
          { value: "129", name:this.$t('ERASMUS_AREA.OTHERS__MEDICAL_SCIENCES') },
          { value: "130", name:this.$t('ERASMUS_AREA.NATURAL_SCIENCES') },
          { value: "131", name:this.$t('ERASMUS_AREA.BIOLOGY') },
          { value: "132", name:this.$t('ERASMUS_AREA.PHYSICS') },
          { value: "133", name:this.$t('ERASMUS_AREA.CHEMISTRY') },
          { value: "134", name:this.$t('ERASMUS_AREA.MICROBIOLOGY_BIOTECHNOLOGY') },
          { value: "135", name:this.$t('ERASMUS_AREA.NUCLEAR_AND_HIGH_ENERGY_PHYSICS') },
          { value: "136", name:this.$t('ERASMUS_AREA.BIOCHEMISTRY') },
          { value: "137", name:this.$t('ERASMUS_AREA.ASTRONOMY_ASTROPHYSICS') },
          { value: "138", name:this.$t('ERASMUS_AREA.OCEANOGRAPHY') },
          { value: "139", name:this.$t('ERASMUS_AREA.OTHERS_NATURAL_SCIENCES') },
          { value: "140", name:this.$t('ERASMUS_AREA.SOCIAL_SCIENCES') },
          { value: "141", name:this.$t('ERASMUS_AREA.POLITICAL_SCIENCES') },
          { value: "142", name:this.$t('ERASMUS_AREA.SOCIOLOGY') },
          { value: "143", name:this.$t('ERASMUS_AREA.ECONOMICS') },
          { value: "144", name:this.$t('ERASMUS_AREA.PSYCHOLOGY_AND_BEHAVIOURAL_SCIENCES') },
          { value: "145", name:this.$t('ERASMUS_AREA.SOCIAL_WORK') },
          { value: "146", name:this.$t('ERASMUS_AREA.INTERNATIONAL_RELATIONS_EUROPEAN_STUDIES') },
          { value: "147", name:this.$t('ERASMUS_AREA.ANTHROPOLOGY') },
          { value: "148", name:this.$t('ERASMUS_AREA.DEVELOPMENT_STUDIES') },
          { value: "149", name:this.$t('ERASMUS_AREA.OTHERS_SOCIAL_SCIENCES') },
          { value: "150", name:this.$t('ERASMUS_AREA.COMMUNICATION_AND_INFORMATION_SCIENCES') },
          { value: "151", name:this.$t('ERASMUS_AREA.JOURNALISM') },
          { value: "152", name:this.$t('ERASMUS_AREA.RADIO_TV_BROADCASTING') },
          { value: "153", name:this.$t('ERASMUS_AREA.PUBLIC_RELATIONS_PUBLICITY_ADVERTISING') },
          { value: "154", name:this.$t('ERASMUS_AREA.LIBRARY_SCIENCE') },
          { value: "155", name:this.$t('ERASMUS_AREA.DOCUMENTATION_ARCHIVING') },
          { value: "156", name:this.$t('ERASMUS_AREA.MUSEUM_STUDIES_CONSERVATION') },
          { value: "159", name:this.$t('ERASMUS_AREA.OTHERS_COMMUNICATION_AND_INFORMATION') },
          { value: "160", name:this.$t('ERASMUS_AREA.OTHER_AREAS_OF_STUDY') },
          { value: "161", name:this.$t('ERASMUS_AREA.PHYSICAL_EDUCATION_SPORT_SCIENCE') },
          { value: "162", name:this.$t('ERASMUS_AREA.LEISURE_STUDIES') },
          { value: "163", name:this.$t('ERASMUS_AREA.HOME_ECONOMICS_NUTRITION') },
          { value: "164", name:this.$t('ERASMUS_AREA.NAUTICAL_SCIENCE_NAVIGATION') },
          { value: "169", name:this.$t('ERASMUS_AREA.OTHERS_IN_OTHER_AREAS_OF_STUDY') },



        ],
          id:null,
          original_name_accompanying_public_document: null,
          title_of_qualification_translated: null,
          eqf_level: null,
          nqf: null,
          load_of_study_program: null,
          enrollment_requirements: null,
          length_of_study: null,
          type_study: null,
          ects: null,
          further_study:null,
          competent_recognition_authority: null,
          name_of_study_program_country_origin:null,
          name_of_foreign_qualification: null,
          study_level:null,
          ects_enrollment:null,
          erasmus_area: null,
          qualification_area: {
            id:null,
            name:null
          },
        insert_user:{
          first_name:null,
          last_name:null
        },
        update_user:{
          first_name:null,
          last_name:null
        },
        created_at:null,
        updated_at:null
        }
    },
    mixins: [getErrorMessage],
    components: {
      SubmitButton,
      DatePicker,
      ValidationDescription,
      Country
    },
    validations: {
        qualification_area:{
          id:{required}
        },
        length_of_study: {required},
        eqf_level: {required},
        name_of_foreign_qualification:{required},
        name_of_study_program_country_origin:{required},
        study_level:{required},
      },
    computed: {
      language(){
        return localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'
      },
      institution(){
        return this.$store.getters['institution/getInstitution']
      },
      applicant() {
        return this.$store.getters['applicant/getApplicant']
      },
      user() {
        return this.$store.getters['user/getUser']
      },

      showTooltipe() {
        return Number(this.user.tooltipe) === 1 ? true : false
      }

    },
    methods: {
      updateRecognitionDate(value) {
        this.recognition_date = value
      },
      formatDate(value){
          if(value){
            const momentDate = new moment(value)
            return momentDate.format('DD.MM.YYYY HH:mm')
          } else {
              return null
          }
      },
      save() {
        let object = {
          name_of_foreign_qualification:this.name_of_foreign_qualification,
          original_name_accompanying_public_document:this.original_name_accompanying_public_document,
          title_of_qualification_translated: this.title_of_qualification_translated,
          eqf_level: this.eqf_level,
          enrollment_requirements: this.enrollment_requirements,
          load_of_study_program: this.load_of_study_program,
          length_of_study: this.length_of_study,
          type_study: this.type_study,
          ects: this.ects,
          qualification_area: this.qualification_area.id,
          nqf:this.nqf,
          further_study:this.further_study,
          erasmus_area: this.erasmus_area,
          name_of_study_program_country_origin:this.name_of_study_program_country_origin,
          study_level: this.study_level,
          ects_enrollment: this.ects_enrollment,
          tab:3
        }
        this.$v.$touch()
        if (this.$v.$invalid) {
          toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 6000
          })
          return
        }
        if (this.id === null) {
          this.createRecognition(object)
        } else {
          this.update(object)
        }
      },
      createRecognition(object) {
        this.loading=true
        object.applicant_id = this.applicant.id
        createRecognition(object)
          .then(response => {
            this.setData(response)
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
              'message': null,
              'type': 'error',
              'timeout': 2000
            })
          }).finally(()=>{
            this.loading = false
        })

      },
      update(object) {
        this.loading = true
        updateRecognition(this.applicant.id,this.id, object)
          .then(response => {
            this.setData(response)
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
          }, error => {
            toast({
              'title': this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE'),
              'message': null,
              'type': 'error',
              'timeout': 2000
            })
          }).finally(()=>{
            this.loading = false
        })
      },
     async fetchRecognition(applicantId){
     await getRecognition(applicantId).then(response => {
             if(response.data.id === null) {
                 this.disabled = true
             }else{
                 this.disabled = false
             }
             this.setData(response)

        }, error => {
        })
      },
      getQualificationList(){
        getQualificationAreaList().then(res => {
          this.qualification_list = res.data
        },() => {
          this.qualification_list = []
        })
      },
      setData(response){
        this.id = response.data.id;
        this.name_of_foreign_qualification = response.data.name_of_foreign_qualification;
        this.original_name_accompanying_public_document = response.data.original_name_accompanying_public_document;
        this.title_of_qualification_translated = response.data.title_of_qualification_translated;
        this.name_of_study_program_country_origin = response.data.name_of_study_program_country_origin;
        this.eqf_level = response.data.eqf_level;
        this.enrollment_requirements = response.data.enrollment_requirements;
        this.load_of_study_program = response.data.load_of_study_program;
        this.length_of_study = response.data.length_of_study;
        this.type_study = response.data.type_study;
        this.ects = response.data.ects;
        this.qualification_area = response.data.qualification_area;
        this.nqf = response.data.nqf;
        this.further_study = response.data.further_study
        this.erasmus_area = response.data.erasmus_area;
        this.study_level = response.data.study_level;
        this.ects_enrollment = response.data.ects_enrollment;
        this.created_at = response.data.created_at;
        this.updated_at = response.data.updated_at;
        this.insert_user = response.data.insert_user;
        this.update_user = response.data.update_user;
      },


    },
    watch:{
      '$route.params.id':{
        handler(applicantId){
          this.getQualificationList()
          this.fetchRecognition(applicantId)
        },
        immediate: true,
        deep:true
      },
      institution:{
        handler(value){
          if(Object.keys(value).length === 0 && this.user.hasOwnProperty('institution') && this.user.institution.id){
            this.$store.dispatch('institution/actionSetInstitution',this.user.institution.id)
          }
        },  immediate:true
      }
    }
  }
</script>

<style lang="scss">

.tooltip-inner {
  background-color: white;
  color: black;
  border: 1px solid #bfc7bd;
}
.hr {
  width:70%;
  text-align:left;
  margin-left:0
}
</style>

